import {AuthorizeHttpClientDecorator} from 'main/decorators';
import {HttpClient} from 'data/protocols/http';
import {makeAxiosHttpClientNoToken} from '../http/axios-http-client-factory-no-token';

export const makeAuthorizeHttpClientDecoratorNoToken = (): HttpClient =>
	new AuthorizeHttpClientDecorator(makeAxiosHttpClientNoToken());
